import { useEffect, useState } from 'react';
import { Box } from '@mantine/core';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { v4 as uuidv4 } from 'uuid';
import stripoTemplate from '../../constants/Stripo';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import Spinner from '../Spinner';
import EmailForm from './EmailForm';

const EmailsNewForm = ({ editor, from, onCreate, onBack, templateId }) => {
  const fetch = useFetch();

  const [email, setEmail] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const [loading, setLoading] = useState(false);
  const [template, setTemplate] = useState();

  const { accountId, domainId } = useParams();
  const { domain } = useSelector((state) => state.domain);

  useEffect(() => {
    if (templateId) {
      fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/stripo/templates/${templateId}`)
        .then(({ template }) => {
          setTemplate(template);
        })
        .catch(setLoadError);
    }
  }, [accountId, domainId, fetch, templateId]);

  const design = JSON.stringify({
    html: template ? template.html : stripoTemplate.html,
    css: template ? template.css : stripoTemplate.css,
  });

  useEffect(() => {
    // The Stripo editor is seeded once from `email.design` and is not re-seeded
    // afterwards (see StripoEditor). So when starting from a gallery template we
    // must wait for that template to load before creating the email — otherwise
    // the editor would initialize with the default template and never pick up
    // the gallery one.
    if (templateId && !template) {
      return;
    }
    if (from) {
      fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/emails/${from}`)
        .then(({ email }) => {
          email.name = `Copy of ${email.name}`;
          delete email.id;
          email.externalId = uuidv4();
          setEmail(email);
        })
        .catch(setLoadError);
    } else {
      setEmail({
        name: 'New email ' + new Date().toString(),
        subject: 'Test email',
        preview: '',
        html: '',
        type: 'visual',
        maxReschedules: 3,
        senderName: domain.senderName,
        onDailyLimitReached: 'reschedule',
        externalId: uuidv4(),
        editor,
        design,
      });
    }
  }, [accountId, domainId, domain.senderName, fetch, editor, from, design, templateId, template]);

  const create = (email, redirect, cb) => {
    setLoading(true);
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/emails`, {
      method: 'POST',
      body: JSON.stringify(email),
    })
      .then(({ email }) => {
        onCreate(email, redirect, cb);
      })
      .catch(setUserError)
      .finally(() => setLoading(false));
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (!email) {
    return <Spinner />;
  }

  return (
    <>
      <EmailForm loading={loading} email={email} saveEmail={create} onBack={onBack} />
      {userError ? (
        <Box ta="left">
          <ErrorMessage message={userError.message} />
        </Box>
      ) : null}
    </>
  );
};

export default EmailsNewForm;
